<template>
	<div class="template_box">
		<div class="content_box">
			<!-- 晒单有礼 -->
			<div class="title_box">
				<div class="title_border"></div>
				<div class="title_text"><span>晒单有礼</span></div>
			</div>
			
			<div class="gift_box">
				<div class="img_box" v-for="(item, index) in productList" :key="item.id">
					<div class="img"><img :src="item.product_src" /></div>
					<div class="product_name" v-show="item.product_name">{{ item.product_name }}</div>
					<div class="product_type">{{ item.product_type }}</div>
				</div>
			</div>
			
			<div class="Activity_content_box">
				<div class="content_for" v-for="(item, index) in text_list" :key="item.id">
					<div class="Activity_content">
						<div class="A_title">{{ item.title }}</div>
						<div class="A_text" v-for="(obj, nn) in item.text_obj" :key="obj.id">
							<div class="aggravation"  v-if="obj.aggravation">{{ obj.aggravation }}</div>
							<div class="reward_tit" v-if="obj.reward_tit">{{ obj.reward_tit }}</div>
							<div class="obj_text"  v-if="obj.text">{{ obj.text }}</div>
							<div class="reward_text" v-if="obj.reward_text">{{ obj.reward_text }}</div>
							<div class="obj_rule" v-if="obj.rule1"><div class="number" v-if="obj.number">1</div><div class="obj_rule_text">{{ obj.rule1 }}</div></div>
							<div class="obj_rule" v-if="obj.rule2"><div class="number" v-if="obj.number">2</div><div class="obj_rule_text">{{ obj.rule2 }}</div></div>
							<div class="notes" v-if="obj.notes">{{ obj.notes }}<span class="star">*</span></div>
							<div class="pour" v-if="obj.pour">{{ obj.pour }}</div>
						</div>
					</div>
					<div class="btn_box">
						<el-button type="primary" class="to_participate" :loading="item.isLoading" @click="to_participate(item)">{{ item.button }}</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Empower from "../../components/empower.vue"
import { ChinaCitys } from "../../plugins/ChinaCitys.js"

export default {
	name: 'Index',
	components: { Empower },
   data() {
		return {
			ChinaCitys: ChinaCitys,
			productList: this.$productList,
			text_list:[
				{
					id:1,
					isLoading: false,
					title: '天猫晒单有礼',
					button: '参与活动',
					text_obj:[
						{
							id:1,
							aggravation: '活动内容：',
							text:'完成订单并按规则晒单的用户，可领取活动礼品一份，每个订单仅限参与一次。',
							pour:'注：如订单发生退款，则相应活动礼品也需退还）'
						},
						{
							id:2,
							reward_tit: '礼品:',
							reward_text:'手机 / 平板通用折叠支架1个',
						},
						{
							id:3,
							reward_tit: '活动规则:',
							number: false,
							rule1:'订单晒图，3张图或视频+20字以上，主要包含产品细节和使用感受等，图片或视频需为所购产品主体。',
							rule2:'',
							notes:'完成任务请提交截图上传至公众号相关活动页，客服审核后，奖励会在5个工作日内发放（大陆地区包邮）',
						},
					]
				},
				{
					id:2,
					isLoading: false,
					title: '京东晒单有礼',
					button: '参与活动',
					text_obj:[
						{
							id:1,
							aggravation: '活动内容:',
							text:'完成订单并按规则晒单的用户，可领取活动礼品一份，每个订单仅限参与一次。',
							pour:'（注：如订单发生退款，则相应活动礼品也需退还）'
						},
						{
							id:2,
							reward_tit: '礼品:',
							reward_text:'手机 / 平板通用折叠支架1个',
						},
						{
							id:3,
							reward_tit: '活动规则:',
							number: false,
							rule1:'订单晒图，3张图或视频+20字以上，主要包含产品细节和使用感受等，图片或视频需为所购产品主体',
							rule2:'',
							notes:'完成任务请提交截图上传至公众号相关活动页，客服审核后，奖励会在5个工作日内发放（大陆地区包邮）'
						},
					]
				}
			],
		  isWeChat: false
		}
   },
	
   mounted(){
		// this.checkWeChat();
		// localStorage.setItem('vx_open_id', '') //1 天猫  2京东
   },
	
	methods: {
		// 返回
		go_back(){
			this.$router.go(-1);
		},
		
		// 参与活动
		to_participate(item){
			console.log(item)
			
			this.text_list.forEach((obj)=>{
				if(obj.id == item.id){
					item.isLoading = true
				}
			})
			setTimeout(() => {
				this.text_list.forEach((obj)=>{
					if(obj.id == item.id){
						item.isLoading = false
					}
				})
			}, 2000); // 2秒后取消加载状态
			localStorage.setItem('source', item.id) //1 天猫  2京东
			let vx_open_id = localStorage.getItem("vx_open_id") ? localStorage.getItem("vx_open_id") : '';
			if(vx_open_id){
				this.$router.push({
					name: 'reward', 
					// params: {
					// 	id: item.id,
					// 	Sunbathing: item.title,
					// } ,
				});
			}else{
				this.$root.$emit('authorize', { url: 'reward' }); // 获取授权信息
			}
			
		},
		
		// checkWeChat() {
		// 	const userAgent = navigator.userAgent.toLowerCase();
		// 	console.log(userAgent)
		// 	if (userAgent.indexOf('micromessenger') !== -1) {
		// 	  this.isWeChat = true;
		// 	}
		// },
   }
}
</script>

<style lang='less' scoped>
.content_box{
	padding-bottom: 80px;
}
.title_box{
	margin-top: 38px;
	height: 36px;
	position: relative;
	display: flex;
	justify-content: center;
	.title_border{
		position: absolute;
		height: 50%;
		width: 65%;
		max-width: 500px;
		min-width: 250px;
		border-bottom: 2px #DDBA80 solid;
	}
	.title_text{
		background-color: #000000;
		z-index: 99;
		width: 32%;
		max-width: 150px;
		min-width: 115px;
		height: 36px;
		span{
			background: linear-gradient(to right, #DCB97E, #ECD9BB);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			font-family: PingFang SC-Medium;
			font-weight: bold;
			font-size: 24px;
		}
	}
}

.gift_box{
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 30px;
	box-sizing: border-box;
	padding: 0px 16px;
	.img_box{
		/* width: 46%; */
		min-width: 250px;
		height: 100%;
		box-sizing: border-box;
		padding: 19px 26px 13px 26px;
		background-image: url('https://oss-gzh.tozo.com.cn/sunbathing/gift_boder.png');
		background-size: 100% 100%;
		position: relative;
		.img{
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			border-radius: 4px;
		}
		img{
			width: 100%;
			max-width: 200px;
			border-radius: 5px;
		}
		.product_name{
			margin-top: 23px;
			font-size: 14px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFD89D;
		}
		.product_type{
			margin-top: 4px;
			font-size: 14px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
		}
	}
	/* .img_box::after {
	    content: "";
	    position: absolute;
	    top: 0;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    border: 2px solid;
	    border-image: linear-gradient(to right, #DAB87D, #EDD8BA);
	    border-image-slice: 1;
	    border-radius: 14px;
	  } */
}


.Activity_content_box{
	.Activity_content::after {
	  content: "";
	  z-index: 0;
	  position: absolute;
	  top: 0px;
	  left: 0px;
	  right: 0px;
	  bottom: 0px;
	  background-image: url('https://oss-gzh.tozo.com.cn/sunbathing/content_border2.png');
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  /* background-size: cover; */
	}
	.Activity_content{
		/* background-image: url('https://oss-gzh.tozo.com.cn/sunbathing/content_border.png'); */
		/* background-size: 100% 100%; */
		/* background-repeat: no-repeat; */
		/* background-size: cover; */
		/* border: 2px solid; */
		/* border-image: linear-gradient(to right, #DAB87D, #EDD8BA); */
		/* border-image-slice: 1; */
		border-radius: 10px;
		margin-top: 90px;
		margin-bottom: 20px;
		width: 100%;
		box-sizing: border-box;
		padding: 33px 12px 24px 12px;
		position: relative;
		.A_title{
			position: absolute;
			width: 50%;
			max-width: 180px;
			min-width: 180px;
			margin-top: -20px;
			margin-left: 0px;
			left: 0;
			top: 0;
			background: linear-gradient(to right, #D6B276, #E0C393);
			text-align: center;
			height: 40px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-top-right-radius: 20px;
			font-size: 17px;
			font-family: PingFang SC-Heavy, PingFang SC;
			font-weight: 800;
			color: #111117;
			z-index: 9;
		}
		.A_text{
			margin-top: 10px;
			font-size: 12px;
			line-height: 16px;
			color: #666666;
			text-align: left;
			z-index: 99;
			position: relative;
			.aggravation{
				margin-top: 16px;
				font-size: 14px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #CAA76B;
				z-index: 9;
			}
			.reward_tit{
				margin-top: 20px;
				font-size: 14px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #DDB674;
				z-index: 9;
			}
			.reward_text{
				margin-top: 8px;
				font-size: 16px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFDDAA;
				z-index: 9;
			}
			.obj_text{
				margin-top: 4px;
				font-size: 12px;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				z-index: 9;
			}
			.obj_rule{
				margin-top: 10px;
				font-size: 14px;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				display: flex;
				z-index: 9;
				.obj_rule_text{
					width: calc(100% - 35px);
					line-height: 25px;
				}
				.number{
					width: 23px;
					height: 23px;
					background: #D7B377;
					border-radius: 25px;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #FFFFFF;
					margin-right: 10px;
					font-size: 14px;
					box-sizing: border-box;
					opacity: 1;
					z-index: 9;
				}
			}
			.notes{
				margin-top: 12px;
				font-size: 12px;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				.star{
					color: red;
				}
			}
			.pour{
				margin-top: 4px;
				display: block;
				text-indent: 0em;
				font-size: 11px;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
			}
		}
	}
	
	.btn_box{
		width: 100%;
		margin-top: 20px;
		display: flex;
		justify-content: center;
		box-sizing: border-box;
		::v-deep .el-button--primary {
		   width: 100%;
			max-width: 500px;
			height: 40px;
			background: linear-gradient(137deg, #EBB666 0%, #FFE7C3 100%);
			border-radius: 6px 6px 6px 6px;
			font-size: 16px;
			font-family: PingFang SC-Heavy, PingFang SC;
			font-weight: 800;
			color: #000000;
			border-color: #000;
		}
	}
}
</style>
